<template>
  <div v-if="!redirectToUserImpact" v-on-clickaway="hideDropdown" class="personal-counter">
    <EButton
      ref="toggle"
      v-focus="open"
      class="personal-counter__button"
      data-track-id="personal-counter-pill"
      data-test-id="personal-counter-toggle"
      icon="tree-color"
      icon-size="m"
      :text-size="isTabletUp ? 'm' : 'xs'"
      mobile-stack
      @click="toggleDropdown"
    >
      <!-- TODO: translate this -->
      <span class="sr-only">Trees you planted: </span>
      <span
        class="personal-counter__text notranslate"
        data-test-id="personal-counter-text"
      >{{ count }}</span>
    </EButton>
    <EDropdown
      :visible="open"
      class="personal-counter__dropdown"
      data-test-id="personal-counter-dropdown"
      :side="isDesktopUp ? 'right' : 'left'"
    >
      <EPersonalCounterContent />
    </EDropdown>
  </div>
  <div v-else class="personal-counter">
    <EButton
      as="nuxt-link"
      target="_blank"
      :to="userImpactTo"
      class="personal-counter__button"
      data-test-id="personal-counter-redirect"
      icon="tree-color"
      icon-size="m"
      :text-size="isTabletUp ? 'm' : 'xs'"
      mobile-stack
    >
      <span class="sr-only">Trees you planted: </span>
      <span
        class="personal-counter__text notranslate"
        data-test-id="personal-counter-text"
      >{{ count }}</span>
    </EButton>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { mixin as clickaway } from 'vue-clickaway';
import { mixin as focus } from 'vue-focus';

import { sendEvent, sendCoreAnalyticsEvent } from '~~/common/js/client/analytics';
import EDropdown from '~~/common/vue/components/dropdown';
import EButton from '~~/common/vue/components/button';
import screen from '~~/common/vue/mixins/screen';
import EPersonalCounterContent from './content';

// TODO: We need to re-think how we want to implement component specific tracking
// adding trackIds to the component directly makes it difficult to re-use the components.
// It also should not be the concern of the component whats beeing tracked
export const trackIds = {
  loggedIn: {
    display: 'personal-counter-content--loggedin',
  },
  loggedOut: {
    display: 'personal-counter-content--loggedout',
  },
};

export default {
  name: 'EOldPersonalCounter',
  components: {
    EDropdown,
    EPersonalCounterContent,
    EButton,
  },
  mixins: [clickaway, focus, screen()],
  props: {
    redirectToUserImpact: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    open: false,
  }),
  computed: {
    ...mapState('global', ['locale']),
    ...mapState('user', [
      'loggedIn',
      'treeCount',
    ]),
    count() {
      return this.treeCount > 0 ? Number(this.treeCount).toLocaleString(this.locale) : 0;
    },
    trackIds() {
      return this.loggedIn ? trackIds.loggedIn : trackIds.loggedOut;
    },
    userImpactTo() {
      return { path: '/your-impact' };
    },
  },
  mounted() {
    this.trackDisplay();
  },
  methods: {
    toggleDropdown() {
      this.open = !this.open;
      this.$emit('dropdown-toggled', { open: this.open });
      this.trackDisplay();
      sendCoreAnalyticsEvent('personalCounterPillClick', { loggedIn: this.loggedIn });
    },
    hideDropdown({ target }) {
      const { $el } = this.$refs.toggle;
      if (target !== $el && !$el.contains(target)) {
        this.open = false;
        this.$emit('dropdown-toggled', { open: this.open });
      }
    },
    trackDisplay() {
      if (this.open) {
        sendEvent(this.trackIds.display);
        sendCoreAnalyticsEvent('personalCounterContentDisplay', { loggedIn: this.loggedIn });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.personal-counter {
  @include desktop {
    position: relative;
  }
}

.personal-counter > .personal-counter__dropdown {
  top: $space-4l + $space-s;
  right: $space-s;
  width: 300px;

  @include tablet {
    @include elevation(2);

    width: 300px;
    border-radius: $border-radius-l;
    background-color: var(--color-background-primary);
  }

  @include desktop {
    margin-top: $space-s;
    top: 100%;
    right: -1 * $space-s;
  }
}

.personal-counter__button {
  color: var(--color-brand-primary);
}

.personal-counter__text {
  color: var(--color-text-primary);
}
</style>
